var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.384766,
    width: 61.2038,
    height: 61.2038,
    rx: 10.2006,
    fill: "#0B60D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 39.486V32.6855",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2266 39.4854V22.4844",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7266 39.4858V29.2852",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0781 30.985C15.0781 23.3713 15.0781 19.5645 17.4434 17.1992C19.8086 14.834 23.6155 14.834 31.2291 14.834C38.8427 14.834 42.6496 14.834 45.0149 17.1992C47.3801 19.5645 47.3801 23.3713 47.3801 30.985C47.3801 38.5985 47.3801 42.4054 45.0149 44.7708C42.6496 47.136 38.8427 47.136 31.2291 47.136C23.6155 47.136 19.8086 47.136 17.4434 44.7708C15.0781 42.4054 15.0781 38.5985 15.0781 30.985Z",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.68468f36b85b3625e0740c6fff585d4f.svg";
export { ForwardRef as ReactComponent };